export const booleanToString = (value: boolean): string => {
  return value ? 'Yes' : 'No';
};
